import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { CREATE_TRANSACTION } from "../../CybersourcePaymentService/graphql/createTransaction.mutate";

const log: any = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICostumeCreateTransactionMethods extends IPluginMethodMap {
  createTransaction(args: any): Promise<any>;
}

export class CostumeCreateTransactionService implements IAgentPlugin {
  readonly methods: ICostumeCreateTransactionMethods;

  constructor() {
    this.methods = {
      createTransaction: this.createTransaction.bind(this),
    };
  }

  async createTransaction(args: any) {
    console.log("costumePageService cybersourceCardCheck args:", args);

    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    if (!client) {
      throw new Error("GraphQL client not found");
    }

    const input = args?.data || {};
    const amount = Number(input?.amount || input?.price || 0);

    if (!amount || Number.isNaN(amount)) {
      throw new Error("Amount is required for card check");
    }

    const data = {
      sessionId: input?.sessionId,
      transientToken: input?.transientToken,
      amount,
      platformFee: input?.platformFee ? Number(input?.platformFee) : undefined,
      firstName: input?.firstName,
      lastName: input?.lastName,
      address1: input?.address1,
      locality: input?.locality,
      administrativeArea: input?.administrativeArea,
      postalCode: input?.postalCode,
      country: String(input?.country || "").toUpperCase(),
      email: input?.email,
      phoneNumber: input?.phoneNumber,
    };

    try {
      const res = await client.mutate({
        mutation: CREATE_TRANSACTION,
        variables: { data },
        fetchPolicy: "no-cache",
      });

      return {
        res: res?.data?.cybersourceCardCheck,
        url: null,
      };
    } catch (err: any) {
      console.log("costumePageService cybersourceCardCheck error", err);

      const displayMessage =
        err?.graphQLErrors?.find((item: any) => item?.extensions)?.extensions
          ?.display_message ||
        err?.message ||
        "CyberSource card check failed";

      throw new Error(displayMessage);
    }
  }
}
